import types from '../../actions/types'
import {combineReducers} from 'redux'
import {createPivotTableReducer} from 'reducers/pivotTable'

export const isVisible = (state = false, action) => {
  switch (action.type) {
    case types.PRODUCTION_SHOW_SETUP_JOB_CARD_DIALOG:
      return true
    case types.PRODUCTION_HIDE_SETUP_JOB_CARD_DIALOG:
      return false
    default:
      return state
  }
}

export const order = (state = null, action) => {
  switch (action.type) {
    case types.PRODUCTION_SHOW_SETUP_JOB_CARD_DIALOG:
      return action.order
    case types.PRODUCTION_HIDE_SETUP_JOB_CARD_DIALOG:
      return null
    default:
      return state
  }
}

export const setupJobCardsDialogPivotTableKey = 'dialogs.setupJobCard.orderItems'

export default combineReducers({
  isVisible,
  order,
  orderItems: createPivotTableReducer({
    key: setupJobCardsDialogPivotTableKey,
    defaultSortColumn: 'createDate',
    defaultSortDirection: 'asc',
    pageSize: 50,
    defaultGridStretch: false,
    defaultAreAllRowsSelected: false,
    defaultCanSelectRows: false,
    retainEdits: false,
    onNewEntity: () => {
    },
  }),
})
